export default "__VITE_ASSET__fa5d9ab7__"